import '@/yomiri/utils/randomUUID.ts';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/index.css';
import { YomiriApp } from '@/yomiri/ui/YomiriApp.tsx';
import { YomiriAuthProvider } from '@/yomiri/auth/YomiriAuth.tsx';

const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(
        <StrictMode>
            <YomiriAuthProvider><YomiriApp /></YomiriAuthProvider>
        </StrictMode>,
    );
}
